"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 编辑器中间手机预览区的宽度（与 configPage 中 .phoneAll 的 400px 保持一致）
var PHONE_WIDTH = 400;
var _default = exports.default = {
  name: 'floatingButton',
  props: {
    datas: Object
  },
  data: function data() {
    return {
      resPath: process.env.VUE_APP_IMAGE_PATH || ''
    };
  },
  computed: {
    /**
     * 外层 sticky 容器样式：
     * - bottom 控制距手机可视区域底部的悬浮距离
     * - justify-content 控制 left/center/right 对齐
     */
    wrapStyle: function wrapStyle() {
      var pos = this.datas.position || 'right';
      var justify = pos === 'left' ? 'flex-start' : pos === 'center' ? 'center' : 'flex-end';
      // 距底部偏移（% 屏幕宽度，按编辑器手机宽 400px 换算）
      var bottomOffset = PHONE_WIDTH * (this.datas.bottomOffset || 0) / 100 + 'px';
      return {
        bottom: bottomOffset,
        /* 配合外层 margin-top:auto 沉底：短页面时也保留距底偏移 */
        marginBottom: bottomOffset,
        justifyContent: justify
      };
    },
    /**
     * 按钮本体样式：宽高、圆角、颜色、透明度、侧边偏移、背景图
     * 宽高均为 px（未设置时回退默认 94px × 37px）。
     */
    /**
     * 背景层样式：宽高、颜色独立配置（bgWidth/bgHeight/bgColor），
     * 未设置时不限制尺寸、不填色，视觉与原来一致。
     */
    bgStyle: function bgStyle() {
      var style = {};
      if (this.datas.bgWidth) style.width = this.datas.bgWidth + 'px';
      if (this.datas.bgHeight) style.height = this.datas.bgHeight + 'px';
      if (this.datas.bgColor) style.backgroundColor = this.datas.bgColor;
      return style;
    },
    btnStyle: function btnStyle() {
      var style = {
        width: (this.datas.buttonWidth || 94) + 'px',
        height: (this.datas.buttonHeight || 37) + 'px',
        padding: '0 10px',
        color: this.datas.textColor,
        opacity: (this.datas.opacity == null ? 100 : this.datas.opacity) / 100,
        borderRadius: this.datas.isRound ? '999px' : '4px'
      };
      // 背景图优先于背景色：有图只用图，无图才用色
      if (this.datas.backgroundImg) {
        style.backgroundImage = 'url(' + this.resPath + this.datas.backgroundImg + ')';
        style.backgroundSize = '100% 100%';
        style.backgroundRepeat = 'no-repeat';
        style.backgroundColor = 'transparent';
      } else {
        style.backgroundColor = this.datas.backgroundColor;
      }
      // 侧边偏移（% 屏幕宽度，按编辑器手机宽 400px 换算；仅 left/right 生效）
      if (this.datas.position === 'left') {
        style.marginLeft = PHONE_WIDTH * (this.datas.sideOffset || 0) / 100 + 'px';
      } else if (this.datas.position === 'right') {
        style.marginRight = PHONE_WIDTH * (this.datas.sideOffset || 0) / 100 + 'px';
      }
      return style;
    }
  },
  methods: {
    /**
     * 装修预览中点击仅做高亮占位，不做真实跳转。
     * 真实跳转由移动端渲染侧根据 httpType/http 处理。
     */
    handleClick: function handleClick() {
      // no-op in editor preview
    }
  }
};